// Blocked Twitch terms content for the library censorship dialog

import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { Badge } from '../../../components/ui/badge';
import { Card, CardContent } from '../../../components/ui/card';
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '../../../components/ui/empty';
import { Spinner } from '../../../components/ui/spinner';
import { Switch } from '../../../components/ui/switch';
import type { LibraryBlockedTermsSyncStatus } from '../hooks';
import type { ModSettings } from '@airhead-games/shared/types';

type BlockedTwitchTermsContentProps = {
  modSettings: ModSettings;
  syncStatus: LibraryBlockedTermsSyncStatus;
  onTwitchTermsBlockedToggle: (checked: boolean) => void;
};

const BlockedTwitchTermsContent: React.FC<BlockedTwitchTermsContentProps> = ({
  modSettings,
  syncStatus,
  onTwitchTermsBlockedToggle,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-sm font-medium">Sync Terms</div>
          <p className="text-xs text-muted-foreground">
            Your blocked Twitch terms will be added to custom profanity
            filtering for your game rooms.
          </p>
        </div>
        <Switch
          checked={modSettings.twitchTermsBlocked}
          onCheckedChange={onTwitchTermsBlockedToggle}
          disabled={!modSettings.censorCustom}
        />
      </div>

      {modSettings.twitchTermsBlocked &&
        (syncStatus === 'syncing' ? (
          <div className="flex min-h-36 flex-col items-center justify-center gap-3 text-sm text-muted-foreground">
            <Spinner className="size-5" />
            <span>Syncing…</span>
          </div>
        ) : (
          <Card>
            <CardContent className="max-h-64 overflow-y-auto">
              {modSettings.censorTwitchWords.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {modSettings.censorTwitchWords.map((word) => (
                    <Badge key={word} variant="secondary">
                      {word}
                    </Badge>
                  ))}
                </div>
              ) : (
                <Empty>
                  <EmptyHeader>
                    <EmptyMedia variant="icon">
                      <ShieldAlert />
                    </EmptyMedia>
                    <EmptyTitle>No blocked terms found</EmptyTitle>
                  </EmptyHeader>
                </Empty>
              )}
            </CardContent>
          </Card>
        ))}
    </div>
  );
};

export default BlockedTwitchTermsContent;
